import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class CardActivationService {
  // private apiUrl = `${environment.PLATFORM_API_URL}/api/v1/store/`;

  constructor(private http: HttpClient) {}

  getBusinessHours(): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    let response = this.http.get<any>(
      `${environment.PLATFORM_API_URL}/api/v1/business-hours/`, // url
      {
        // options
        headers: headers,
      }
    );

    return response;
  }

  getMerchantDetails(): Observable<any> {
    // const storeDataJSON = localStorage.getItem('merchant-store');
    // const storeData = storeDataJSON && JSON.parse(storeDataJSON);
    const merchantId = localStorage.getItem('userId');

    if (!merchantId) {
      return throwError('No merchant ID found in local storage');
    }

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    let response = this.http.get<any>(
      `${environment.PLATFORM_API_URL}/api/v1/merchant-info/${merchantId}/`, // url
      {
        // options
        headers: headers,
        withCredentials: true
      }
    );

    return response;
  }

  getSocmedLinks(): Observable<any> {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    let response = this.http.get<any>(
      `${environment.PLATFORM_API_URL}/api/v1/store-links/`, // url
      {
        // options
        headers: headers,
      }
    );

    return response;
  }

  getUploadedDocuments(): Observable<any> {
    const merchantId = localStorage.getItem('userId');
    let response = this.http.get<any>(
      `${environment.MERCHANT_EXTRAS}/extrasapi/documents/${merchantId}` // url
    );
    return response;
  }

  updateStore(
    shop_name: string | null,
    shop_category: string | null,
    is_whole_day: boolean | null,
    storeLinksForm: any
  ): Observable<any> {
    console.log('Updating store');
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    const body = {
      store: {
        shop_name: shop_name,
        shop_category: shop_category,
        is_whole_day: is_whole_day,
      },
      social_media_links: {
        facebook: storeLinksForm.facebook,
        instagram: storeLinksForm.instagram,
        tiktok: storeLinksForm.tiktok,
        youtube: storeLinksForm.youtube,
      },
    };

    let response = this.http.post<any>(
      `${environment.PLATFORM_API_URL}/api/v1/store/`, // url
      body, // body
      {
        // options
        headers: headers,
      }
    );

    return response;
  }

  setCheckpoint(index: string): void {
    // Since some have subpages, index should be a string so we can set it to 3_2 for page 3 part 2
    const userId = localStorage.getItem('userId');
    if (userId) {
      console.log(userId);
      const checkPointIndex = `${userId}_${index}`;
      localStorage.setItem('cardActivationCheckpoint', checkPointIndex);
    }
  }

  getCheckpoint(): string | null {
    const userId = localStorage.getItem('userId');
    if (userId) {
      if (localStorage.getItem('cardActivationCheckpoint')) {
        let checkPoint = localStorage.getItem('cardActivationCheckpoint')!;
        checkPoint = checkPoint.replace(userId + '_', '');
        return checkPoint;
      }
    }
    return null;
  }

  createMorePayments(business_type: string): Observable<any> {
    const merchantId = localStorage.getItem('userId') ?? '';

    const body = {
      user_id: parseInt(merchantId),
      business_type: business_type,
    };

    let response = this.http.post<any>(
      `${environment.MERCHANT_EXTRAS}/payments/v1/create`,
      body
    );

    return response;
  }
}
